import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
    import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Tag } from "primereact/tag";

const faixasCores = [
    { limite: 18, cor: '#92d050' }, // 18 a ...
    { limite: 12, cor: '#ffc000' }, // 12 a 17
    { limite: 5,  cor: '#ff0000' }, // 5 a 11
    { limite: 0,  cor: '#7a0000' }  // 0 a 4
];

export function formatColor(rowData, field) {
    const valor = rowData[field];
    if (valor === undefined || valor === null) return "";
   
    const config = faixasCores.find(f => parseInt(valor) >= f.limite);
    const cor = config ? config.cor : "#888";

    const formatado = Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(parseInt(valor));

    return (
        <Tag 
            value={`${formatado}%`} 
            style={{ 
                background: cor, 
                color: '#fff',
                fontWeight: 'bold',
                padding: '0.25rem 0.5rem'
            }}
            rounded
        />
    );
}

export function PremioGeral({ data, producaoTotal, ocultarNomes }) {
    const [geral, setGeral] = useState();
    const ref = useRef();

    const handlePrint = useReactToPrint({
        content: () => ref.current
    });

    useEffect(() => {
        if (!data) return;
        let items = data.filter((element) => {
            return element.tipo === '1';
        });

        setGeral(items);
    }, [data]);

    const calcQualidade = (rowData) => {
        const prodGeral = Number(producaoTotal) || 0;
        const defeito = Number(rowData.metragem) || 0;
        
        if (prodGeral === 0 || defeito === 0) return "0,00%";
        
        const porcentagem = (defeito / prodGeral) * 100;
        return porcentagem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "%";
    };

    const totalMetragemDefeito = (() => {
        const item = geral?.find(item => item.tipof === "Geral");
        return Number(String(item?.metragem || 0).replace('m', '').replace(',', '.'));
    })();

    return (
        <div>
            <Button 
                className="p-m-1"
                icon="pi pi-print"
                onClick={handlePrint}
            />
            
            <div ref={ref}>
                <h3>Geral</h3>
                <p style={{marginTop: '-15px', fontWeight: '600'}}>
                    Total Metragem Defeito: <span style={{ color: '#7a0000', fontWeight: 700 }}>{totalMetragemDefeito.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m</span>
                </p>
                <p style={{marginTop: '-15px', fontWeight: '600'}}>
                    Total Metragem Produzida: <span style={{ color: '#00397a', fontWeight: 700 }}>{Number(producaoTotal || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m</span>
                </p>
                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    rowHover
                    stripedRows
                    size="small"
                    value={geral}
                >
                    {!ocultarNomes && (
                        <Column header="Colaborador" field="nome" sortable style={{ minWidth: "200px", width: "20%" }} />
                    )}
                    <Column header="Tipo" field="tipof" sortable />
                    <Column header="Metragem" field="metragem" sortable body={(r) => Number(r.metragem).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "m"} />
                    <Column header="Qualidade" body={calcQualidade} style={{ fontWeight: 'bold' }} />
                    <Column header="Prêmio de Qualidade" field="premio" sortable body={(rowData) => formatColor(rowData, 'premio')} />
                </DataTable>
            </div>
        </div>
    )
}